import { SocialUser } from '@abacritt/angularx-social-login';
import { accountResetPasswordReq } from '@biz-models/network/account-model-network';
import { LoginNetworkModel, LoginRespModel, socialLinkReq, socialLinkResp } from '@biz-models/network/login-authenticate-network.model';
import { TenantAccount } from '@biz-models/shared/current-user.model';
import { createActionGroup, emptyProps } from '@ngrx/store';

export const authentication = createActionGroup({
	source: 'Authenticate User',
	events: {
		LoginInit: (payload: LoginNetworkModel) => ({ payload }),
		LoginSuccess: (payload: LoginRespModel[]) => ({ payload }),
		LoginFail: (error: string) => ({ error }),

		AuthTokenSuccess: (payload: TenantAccount[]) => ({ payload }),

		ResetPassword: (payload: accountResetPasswordReq) => ({ payload }),
		ResetPasswordSuccess: (payload: any) => ({ payload }),

		FBLogin: emptyProps(),

		GoogleLogin: emptyProps(),

		LoginSocialSuccess: (payload: any) => ({ payload }),

		AuthStateChanged: (payload: SocialUser) => ({ payload }),

		SettingsLoginInit: (payload: LoginNetworkModel) => ({ payload }),
		SettingsLoginSuccess: (payload: LoginRespModel[]) => ({ payload }),
		SettingsLoginFail: (error: Error) => ({ error }),

		SettingLoginSuccess: (payload: LoginRespModel[]) => ({ payload }),

		LogoutAccount: emptyProps(),
		LogoutAccountSuccesss: (payload: any) => ({ payload }),
		LogoutAccountFail: (payload: Error) => ({ payload }),
	},
});
